export const releaseTagRegex = /https:\/\/tag-.*\.switchboard\.engineering\//;
